import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Spinner
} from 'reactstrap';
import { updateAdvertiser } from 'service/advertiser.service';
import { deleteAdvertiser } from 'service/advertiser.service';
import { addAdvertiser } from 'service/advertiser.service';
import { getAdvertisers } from 'service/advertiser.service';
import Avatar from './Avatar';

const Advertiser = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [advertiserData, setAdvertiserData] = useState([]);
  const [newAdvertiser, setNewAdvertiser] = useState({
    name: '',
    profileImageUrl: '',
    shortName: '',
    id: 0,
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  useEffect(() => {
    fetchAdvertisers();
  }, []);

  const toggleModal = () => {
    setIsUpdate(false);
    setIsSubmitting(false);
    setNewAdvertiser({ name: '', profileImageUrl: '', shortName: '' });
    setModalOpen(!modalOpen);
  };

  const toggleUpdateModal = (advertiser) => {
    setNewAdvertiser(advertiser);
    setIsSubmitting(false);
    setIsUpdate(true);
    setModalOpen(!modalOpen);
  };

  const fetchAdvertisers = async () => {
    try {
      const advertisers = await getAdvertisers();
      console.log(advertisers);
      setAdvertiserData(advertisers.data.data.rows);
    } catch (error) {
      console.error('Error fetching advertisers:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewAdvertiser((prevData) => ({ ...prevData, [name]: value }));

    if (name === 'name') {
      generateShortName(value);
    }

    setFormErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  
  };

  const generateShortName = (text) => {
    const words = text.trim().split(' ');
    let initials = '';

    if (words.length === 1) {
      const word = words[0].toUpperCase();
      if (word.length >= 2) {
        initials = word.substring(0, 2);
      } else {
        initials = word.padEnd(2, '_');
      }
    } else {
      words.forEach((word) => {
        initials += word.charAt(0).toUpperCase();
      });
    }
    setNewAdvertiser((prevData) => ({ ...prevData, shortName: initials }));
  };

  const handleFormSubmit =async (e) => {
    e.preventDefault();

    // Perform form validation
    const errors = {};
    if (newAdvertiser.name.trim() === '') {
      errors.name = 'Name is required';

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    }else{
      setIsSubmitting(true);
      try {
        const addedAdvertiser = await addAdvertiser(newAdvertiser);
        setIsSubmitting(false);
        setAdvertiserData((prevData) => [...prevData, newAdvertiser]);
        setNewAdvertiser({ name: '', profileImageUrl: '', shortName: '' });
        toggleModal();
      } catch (error) {
        console.error('Error adding advertiser:', error);
      }
    }


  };
  const handleFormUpdate =async (e) => {
    e.preventDefault();

    // Perform form validation
    const errors = {};
    if (newAdvertiser.name.trim() === '') {
      errors.name = 'Name is required';

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    }else{
      setIsSubmitting(true);
      // console.log(newAdvertiser);
      try {
        const addedAdvertiser = await updateAdvertiser(newAdvertiser.id, newAdvertiser);
        setIsSubmitting(false);
        fetchAdvertisers()
        toggleModal();
      } catch (error) {
        console.error('Error adding advertiser:', error);
      }
    }


  };
  const handleDeleteAdvertiser = async (id) => {
    try {
      await deleteAdvertiser(id);
      setAdvertiserData((prevData) => prevData.filter((advertiser) => advertiser.id !== id));
    } catch (error) {
      console.error('Error deleting advertiser:', error);
    }
  };

  return (

    <><div className="container-fluid py-4">
        <div className="row">
          <Card>
            <CardHeader className="d-flex justify-content-between">
              <h5>Advertiser</h5>
              <Button color="secondary" onClick={toggleModal}>
                <i className="ni ni-fat-add" /> Add Advertiser
              </Button>
            </CardHeader>

            <div className="p-4">
              <Table responsive>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>ShortName</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {advertiserData.map((advertiser, index) => (
                    <tr key={index}>
                      <td>
                        <div class="d-flex align-items-center">
                          <Avatar profileImageUrl={advertiser.profileImageUrl} name={advertiser.shortName} />


                          <span className='text-bold'>{advertiser.name}</span>
                        </div>

                      </td>
                      <td>{advertiser.shortName}</td>

                      <td class="text-sm">
                        <Button color='success' className=" btn btn-sm mx-3 text-white" onClick={() => toggleUpdateModal(advertiser)}>
                          <i class="fas fa-user-edit " aria-hidden="true"></i>
                        </Button>
                        <Button color='danger' className='btn btn-sm text-white' onClick={() => handleDeleteAdvertiser(advertiser.id)}>
                          <i class="fas fa-trash" aria-hidden="true"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Card>

          <Modal isOpen={modalOpen} toggle={toggleModal} size="md">
            <ModalHeader toggle={toggleModal}>Add Advertiser</ModalHeader>
            <ModalBody>
              <form onSubmit={handleFormSubmit}>
                <FormGroup>
                  <Label for="name">Name</Label>
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    value={newAdvertiser.name}
                    onChange={handleInputChange}
                    invalid={!!formErrors.name} />
                  {formErrors.name && <FormFeedback>{formErrors.name}</FormFeedback>}
                </FormGroup>
                <FormGroup>
                  <Label for="email">Profile Image Url</Label>
                  <Input
                    type="text"
                    name="profileImageUrl"
                    value={newAdvertiser.profileImageUrl}
                    onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                  <Label for="phone">Short Name</Label>
                  <Input
                    type="text"
                    name="shortName"
                    id="phone"
                    value={newAdvertiser.shortName}
                    onChange={handleInputChange}
                    invalid={!!formErrors.shortName} />
                  {formErrors.shortName && <FormFeedback>{formErrors.shortName}</FormFeedback>}
                </FormGroup>
              </form>
            </ModalBody>
            <ModalFooter>
              {!isUpdate ?
                <Button color="primary" onClick={handleFormSubmit} disabled={isSubmitting}>
                  {isSubmitting ? <Spinner size="sm" color="light" /> : 'Submit'}
                </Button>
                : <Button color="primary" onClick={handleFormUpdate} disabled={isSubmitting}>
                  {isSubmitting ? <Spinner size="sm" color="light" /> : 'Update'}
                </Button>}
              <Button color="secondary" onClick={toggleModal}>
                Close
              </Button>

            </ModalFooter>
          </Modal>
        </div>
      </div></>
  );
};

export default Advertiser;
